import {
  Checkbox as HeadlessCheckbox,
  type CheckboxProps as HeadlessCheckboxProps,
} from "@headlessui/react";
import { Check } from "@untitled-ui/icons-react";
import classNames from "classnames";
import { type ElementType, useContext } from "react";

import { FieldContext } from "./FieldContext";

const sizes = {
  sm: "h-4 w-4",
  md: "h-5 w-5",
};

export type CheckboxProps<T extends ElementType = "span"> = {
  size?: keyof typeof sizes;
} & HeadlessCheckboxProps<T>;

export default function Checkbox({
  className,
  size = "md",
  ...props
}: CheckboxProps<"span">) {
  const fieldContext = useContext(FieldContext);

  return (
    <HeadlessCheckbox
      {...props}
      className={({ hover, focus, checked, active }) =>
        classNames(
          "group ring-primary-100 flex shrink-0 items-center justify-center rounded-md border data-disabled:bg-gray-100",
          checked
            ? "border-primary-600 bg-primary-50 data-disabled:border-gray-300"
            : "border-gray-300",

          hover && !(active || focus) && "border-primary-600 bg-primary-100",

          (active || focus) && "border-primary-300 ring-4",

          fieldContext.grid && "sm:col-span-2",
          sizes[size],
          className,
        )
      }
    >
      <Check className="text-primary-600 hidden size-4 group-data-checked:block group-data-disabled:text-gray-300" />
    </HeadlessCheckbox>
  );
}
